import React from 'react';

import { Filler, ProgressBarContainer } from './styled';

const ProgressBar = ({ value, maxValue }) => {
  const progressPercentage = (value / maxValue) * 100;

  return (
    <ProgressBarContainer>
      <Filler progress={progressPercentage} />
    </ProgressBarContainer>
  );
};

export default ProgressBar;
